
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import GalleryItem from "../common/GalleryItem";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";
import { IGallery } from "../../../../../services";

export interface GalleryPreviewProps {
    basePath: string;
    gallery: IGallery[];
}

function GalleryPreview({ basePath, gallery }: GalleryPreviewProps) {

    const labels = i18nManager.Labels.home;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);

    if (!gallery.length) return null;

    return (<section className={styles["section"]}>
        <div className={styles["container"]}>
            <SectionHeader eyebrow={labels.gallery_eyebrow} title={labels.gallery_title} titleEm={labels.gallery_title_em}
                action={<Btn variant="ghost" size="sm" to={{ pathname: pagePath(basePath, "GALLERY"), search: searchParams.toString() }}>{i18nManager.Labels.view_all} <i className="fa fa-arrow-right" /></Btn>} />
        </div>
        <div className={styles["gallery-mosaic"]}>
            {gallery.map((g, i) => (<GalleryItem key={g.external_id} gallery={g} wide={i % 5 === 2} />))}
        </div>
    </section>);
}

export default GalleryPreview;
